// Configurazioni specifiche per ogni ambiente
export const environments = {
  development: {
    name: 'Development',
    apiBaseUrl: 'http://localhost:5000',
    debug: true,
    logLevel: 'debug',
    timeout: 10000
  },
  'azure-dev': {
    name: 'Azure Development',
    apiBaseUrl: 'https://basiccockpit-api-dev.azurewebsites.net',
    debug: true,
    logLevel: 'debug',
    timeout: 15000
  },
  staging: {
    name: 'Staging',
    apiBaseUrl: 'https://basiccockpit-api-dev.azurewebsites.net',
    debug: true,
    logLevel: 'info',
    timeout: 15000
  },
  production: {
    name: 'Production',
    apiBaseUrl: 'https://basiccockpit-api.azurewebsites.net',
    debug: false,
    logLevel: 'error',
    timeout: 20000
  }
};

// Configurazione per ambiente di test
export const testEnvironment = {
  name: 'Test',
  apiBaseUrl: 'http://localhost:5001',
  debug: true,
  logLevel: 'debug',
  timeout: 5000
};

// Unica variabile per l'ambiente: REACT_APP_ENV ('development' | 'azure-dev' | 'production' | 'staging')
const getEnv = () => process.env.REACT_APP_ENV;

// Funzione per ottenere la configurazione dell'ambiente corrente (solo REACT_APP_ENV).
export const getEnvironmentConfig = () => {
  const env = getEnv();
  if (env === 'azure-dev') return environments['azure-dev'];
  if (env === 'production') return environments.production;
  if (env === 'staging') return environments.staging;
  return environments.development;
};

// Funzione per verificare se siamo in development
export const isDevelopment = () => getEnv() !== 'azure-dev' && getEnv() !== 'production' && getEnv() !== 'staging';

// Funzione per verificare se siamo in production
export const isProduction = () => getEnv() === 'production';

// Funzione per verificare se siamo in staging
export const isStaging = () => getEnv() === 'staging';

// Funzione per verificare se siamo in Azure Dev
export const isAzureDev = () => getEnv() === 'azure-dev';

// Funzione per ottenere configurazione Azure Dev
export const getAzureDevConfig = () => {
  return {
    name: 'Azure Development',
    apiBaseUrl: 'https://basiccockpit-api-dev.azurewebsites.net',
    debug: true,
    logLevel: 'debug',
    timeout: 15000
  };
};
